import React from "react";
import { connect } from "react-redux";
import RequestControls from "containers/request/RequestControls";
import { countCheckedAgreements } from "containers/request/LicenseAgreement/BatteryAgreement/agreementHelper";
import {
  submitInitialBSC,
  signSavedInitialBSC
} from "actions/battery/bscRequest";
import { getAgreementList } from "dictionaries/BatteryAgreementTypes";

const BatteryAgreementControlsBSC = ({
  app,
  request,
  user,
  wizard,
  submitInitialBSC,
  signSavedInitialBSC
}) => {
  if (!request) return null;

  const { idPRR, idACR, idARR } = app;
  const requestWithCertTypes = { ...request, idPRR, idACR, idARR }; // need them for submission
  const wizardSubmitHandler = () => submitInitialBSC(requestWithCertTypes);

  let onSaveHandler;

  let isValid;
  let validToSave;
  let validToSubmit;
  let agreedAmount = 0;

  // logic for submission
  if (wizard) {
    const { requiredAgreements } = wizard.batteryCert.certInfo;
    const totalAgreements = requiredAgreements.length;

    // let's count how many checkboxes selected on agreement page
    agreedAmount = countCheckedAgreements(request);

    // can request be saved
    if (request.canBeSaved && agreedAmount === 0) {
      validToSave = true;
    }

    // can request be submitted
    else if (agreedAmount === totalAgreements) {
      validToSubmit = true;
    }
  } else {
    // logic for existed request
    if (user.isVendor && !request.agreementAccepted) {
      onSaveHandler = () => {
        return signSavedInitialBSC(request.model.id, request.id, request.ieee);
      };

      const totalAgreements = getAgreementList(request).length || 0;

      // let's count how many checkboxes selected on agreement page
      agreedAmount = countCheckedAgreements(request);

      // can request be saved
      if (agreedAmount === totalAgreements) isValid = true;
    }
  }

  return (
    <RequestControls
      show={true}
      isValid={isValid}
      isValidToSave={validToSave}
      isValidToSubmit={validToSubmit}
      onSave={onSaveHandler}
      onSubmit={wizardSubmitHandler}
      onWizardSave={wizardSubmitHandler}
    />
  );
};

function mapStateToProps({ app, request, wizard, user }) {
  return { app, request, wizard, user };
}

export default connect(mapStateToProps, {
  submitInitialBSC,
  signSavedInitialBSC
})(BatteryAgreementControlsBSC);
